<div class="row center-card">
  <div class="center-left" *ngIf="currentTab === 1" (click)="goToCenter()">
    <i class="fas fa-chevron-right"></i>
  </div>
  <div class="left" (click)="goToAboutMe()" *ngIf="currentTab === 2">
    <span>{{ "about_me" | translate }}</span>
    <i class="fas fa-chevron-left"></i>
  </div>
  <div class="center-right" (click)="goToCenter()" *ngIf="currentTab === 3">
    <i class="fas fa-chevron-left"></i>
  </div>
  <div class="right" (click)="goToService()" *ngIf="currentTab === 2">
    <span>{{ "services" | translate }}</span>
    <i class="fas fa-chevron-right"></i>
  </div>
  <div class="col-6 box-container">
    <div class="box-center">
      <img
        [src]="logoImage"
        [ngClass]="{ 'd-none': publicCardData.urlLogotipo === '' }"
      />
      <h1>{{ publicCardData.nombre }}</h1>
      <hr />
      <span>{{ publicCardData.profesion }}</span>
      <hr />
      <span *ngIf="publicCardData.empresa !== ''">{{
        publicCardData.empresa
      }}</span>
    </div>
  </div>
  <div class="col-6">
    <div class="box-img">
      <img [src]="coverImage" *ngIf="coverImage" />
      <img src="assets\img\imagge.jpg" *ngIf="!coverImage" class="img-fluid" />
    </div>
  </div>
</div>
